export type MarketRoutes = ReadonlyArray<string>;

export const marketRoutes: MarketRoutes = ["/register-market"];

export default marketRoutes;
